import styled from 'styled-components';

const colorFactory = (color: string) => (element: any) => styled(element)`
  color: ${props => props.theme[color]};
`;

export const primaryFactory = colorFactory('primary');
export const secondaryFactory = colorFactory('secondary');



// WEBPACK FOOTER //
// ./src/services/themeColors.ts